export const MAX_DOWNLOAD_FILES = 400

/** Form field for selecting unlabelled mixes when no labelled mix/cutdown options exist. */
export const ADD_ALL_MIXES_FIELD = 'mixes-all'

/**
 * Internal marker (not shown to users) for the option covering mixes that have
 * neither mix type nor mix variation. Used for the form field name and to pick
 * the Locize 'other' translation as the display label.
 */
export const UNLABELLED_MIX_OPTION_KEY = 'Other'

/** Form field for selecting all available stems. */
export const ADD_ALL_STEMS_FIELD = 'stems-all'
